const pluralCheck = (count: number) => (count === 1 ? '' : 's');

export default pluralCheck;
